@for (topClass of top5Classes; track topClass) {
  <div class="top-class" (click)="selectClass.emit(topClass.name)">
    <div
      class="class-color-circle"
      [style.background-color]="topClass.color"
    ></div>
    <div class="body-02 class-label" h3Truncate>
      {{ topClass.label }}
    </div>
  </div>
}
